<template>
  <div id="app">
    <div class="container">
      <p class="text-right">
        <span class="badge badge-pill badge-light">{{ version }}</span>
      </p>
    </div>
    <!-- コンテンツ -->
    <div class="container mt-5 p-lg-5 bg-light">
      <vue-loading
        type="bubbles"
        color="#ced4da"
        :size="{ width: '50px', height: '50px' }"
        v-show="isInitialized === false"
      ></vue-loading>
      <transition mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <!-- 著作権情報 -->
    <footer class="footer">
      <div class="container mt-3 p-lg-2 bg-light">
        <p class="text-center">
          <span
            class="badge badge-pill badge-light"
          >{{ copyright }}</span>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);
import { VueLoading } from "vue-loading-template";

export default {
  name: "App",
  components: {
    VueLoading
  },
  computed: {
    //Copyright © HealthCare Relations Co., Ltd. All rights reserved
    copyright() {
      return this.$store.state.ehrSystem.copyright;
    },
    //「参加する」ボタンの表示（true:表示 false:非表示）
    isInitialized() {
      return this.$store.state.isInitialized;
    },
    // アプリケーションバージョン
    version() {
      return this.$store.state.version;
    }
  },
  beforeCreate() {
    // PHRデバック用(コメントアウトで)
    // window.pPhrSystemLink.phrUserId = "00001";
    // window.pPhrSystem.phrAlias = "phr";

    /* ##### パラメータの保存 ##### */
    // デフォルトパラメータをストアに保存
    this.$store.commit("setDefaultParams", window.pDefaultParams);
    this.$store.commit("setSymbolToggle", window.pDefaultParams.symbolToggle);
    this.$store.commit("setNumberToggle", window.pDefaultParams.numberToggle);
    
    // 申請情報をストアに保存
    this.$store.commit("setConsentApplicant", window.pConsentApplicant);
    // PHRシステム連携をストアに保存
    this.$store.commit("setPhrSystemLink", window.pPhrSystemLink);
    // PHRシステムをストアに保存
    this.$store.commit("setPhrSystem", window.pPhrSystem);

    // 要求先URLのデフォルトを設定
    const requestDomain = process.env.VUE_APP_API_BASE_URL;
    this.$store.commit("setRequestDomain", requestDomain);

    // TOP画面の状態初期値
    this.$store.commit("setDisplayName", "未参加");
    this.$store.commit("setVersion", window.pVersion ? window.pVersion : "UNDER NODE SERVER");
    this.$store.commit("setIsInitialized", true);
},
  created() {},
  beforeMount() {},
  mounted() {}
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  overflow-x: hidden;
}

h3 {
  padding: 0.5em; /*文字周りの余白*/
  color: #010101; /*文字色*/
  background: #eaf3ff; /*背景色*/
  border-bottom: solid 3px #516ab6; /*下線*/
  text-align: center;
}

/* トランジション */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>
